import script from "./KMenuLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./KMenuLocation.vue?vue&type=script&setup=true&lang=js"

import "./KMenuLocation.vue?vue&type=style&index=0&id=2696ccc2&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2696ccc2"]])

export default __exports__